import React from 'react'
import style from '../card.module.css'
function English() {
  return (
    <div className={style.syllabus_card}>
        <div>    
          <h3>English</h3>  
          <p>1 upcoming . 312 courses</p>      
        </div>   
        <p>English Grammer,Vocabulary, Reading and more</p>        
    </div>
  )
}
export default English